module.exports = __webpack_public_path__ + "img/sunset-streefkerk.1f346709.jpg";